import { getParentByClass, getParentByDataAttribute } from "../helper/helper";

export default function initPosttypeFilter() {
  const posttypeFilters = document.querySelectorAll(".filter-posttype");

  for (let i = 0; i < posttypeFilters.length; i++) {
    posttypeFilters[i].addEventListener("click", function (event) {
      doFilterPosttype(posttypeFilters[i]);
    });
  }

  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("posts__loadmore")) {
      doLoadmorePosts(e.target);
    }
  });
}

function doFilterPosttype(element) {
  const posttype = element.dataset.posttype;
  const categorySlug = element.dataset.categoryslug;
  const filterValues = [element.dataset.tax];
  const listEle = document.getElementById("filter-posttype-list");
  //   listEle.innerHTML = "";
  listEle.classList.add("mb-loading");

  const posttypeFilters = document.querySelectorAll(
    ".filter-posttype.btn-active"
  );

  for (let i = 0; i < posttypeFilters.length; i++) {
    posttypeFilters[i].classList.remove("btn-active");
  }

  listEle.dataset.catids = filterValues.join(",");

  jQuery.ajax({
    type: "POST",
    url: globalvars.ajaxurl,
    data: {
      action: "filter_posttype_ajaxhandler",
      nonce: globalvars.ajax_nonce,
      offset: 0,
      catids: filterValues,
      postsperpage: listEle.dataset.postsPerPage,
      posttype: posttype,
      categorySlug: categorySlug,
    },
    beforeSend: function () {},
    complete: function () {},
    success: function (data) {
      element.classList.add("btn-active");
      listEle.classList.remove("mb-loading");
      listEle.innerHTML = data;

      // hide filter list
      const filterList = getParentByClass(element, "filter-list");

      if (filterList) {
        filterList.classList.remove("open");
        const filterListSelector = filterList.getAttribute("id");
        const filterListToggle = document.querySelector(
          "[data-toggle-filter='" + filterListSelector + "']"
        );

        if (filterListToggle) {
          filterListToggle.classList.remove("open");
        }
      }
    },
    error: function (MLHttpRequest, textStatus, errorThrown) {
      alert(textStatus, errorThrown);
    },
  });
}

function doLoadmorePosts(element) {
  const posttype = element.dataset.posttype;
  const categorySlug = element.dataset.categoryslug;

  const loadmoreWrapper = getParentByClass(element, "posts__loadmore__wrapper");

  element.remove();
  loadmoreWrapper.remove();

  const listEle = document.getElementById("filter-posttype-list");
  const listItems = document.querySelectorAll(
    "#filter-posttype-list .com-postlinks__preview"
  );

  const count = listItems.length;
  const filterValues = listEle.dataset.catids;
  const filterValuesArray = filterValues.split(",");

  jQuery.ajax({
    type: "POST",
    url: globalvars.ajaxurl,
    data: {
      action: "filter_posttype_ajaxhandler",
      nonce: globalvars.ajax_nonce,
      offset: count,
      catids: filterValuesArray,
      postsperpage: listEle.dataset.postsPerPage,
      posttype: posttype,
      categorySlug: categorySlug,
    },
    beforeSend: function () {},
    complete: function () {},
    success: function (data) {
      element.classList.add("btn-active");
      listEle.classList.remove("mb-loading");
      listEle.innerHTML += data;
    },
    error: function (MLHttpRequest, textStatus, errorThrown) {
      alert(textStatus, errorThrown);
    },
  });
}
